// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tab--q07gh {
  padding: 10px 0;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__sectionLabel--slBXT {
  font-size: 11px;
  font-weight: 600;
  color: #9b9b9b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tablesRow--dbKLj {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tableHalf--Z0c1D {
  flex: 1;
  min-width: 0;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessage--WES8j {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 80px;
  min-height: 300px;
  color: #6b6b6b;
  text-align: center;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessageTitle--MJDxz {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}

.src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessageSubtitle--d2jFL {
  font-size: 16px;
  color: #9b9b9b;
}

@media (max-width: 768px) {
  .src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tablesRow--dbKLj {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/tripsMonitoredTab.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".tab {\n  padding: 10px 0;\n}\n\n.sectionLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9b9b9b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.tablesRow {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.tableHalf {\n  flex: 1;\n  min-width: 0;\n}\n\n.stateMessage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 80px;\n  min-height: 300px;\n  color: #6b6b6b;\n  text-align: center;\n}\n\n.stateMessageTitle {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.stateMessageSubtitle {\n  font-size: 16px;\n  color: #9b9b9b;\n}\n\n@media (max-width: 768px) {\n  .tablesRow {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tab--q07gh`,
	"sectionLabel": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__sectionLabel--slBXT`,
	"tablesRow": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tablesRow--dbKLj`,
	"tableHalf": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__tableHalf--Z0c1D`,
	"stateMessage": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessage--WES8j`,
	"stateMessageTitle": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessageTitle--MJDxz`,
	"stateMessageSubtitle": `src-js-pages-usageReportingContainer-tripsMonitoredTab-module__stateMessageSubtitle--d2jFL`
};
export default ___CSS_LOADER_EXPORT___;
